<template lang="pug">
.order-pack__row(:class="rowClass")
  .order-pack__cell.order-pack__col-check(v-if="showCheck")
    shCheckbox(
      :value="selected"
      @input="$emit('select', $event)"
      :icon-color="iconColor"
      :icon-size="iconSize"
    )
  .order-pack__cell.order-pack__col-number
    span.tag.uppercase(
      :class="[`bg-${item.brand}`, { 'order-pack__id-link': linkIds }]"
      @click.stop="onChangeClick"
    ) c{{ item.change }}
  .order-pack__cell.order-pack__col-status
    .tag.order-pack__status-label(:style="statusStyle") {{ statusLabel }}
    .tag.order-pack__quantity {{ productQuantity }}
  .order-pack__cell.order-pack__col-name.capitalize {{ name }}
  .order-pack__cell.order-pack__col-location.capitalize {{ location }}
  .order-pack__cell.order-pack__col-date {{ dateLabel }}
  .order-pack__cell.order-pack__col-remit(@click.stop="")
    RemitDataIcon(:record="item" :icon-color="iconColor" :icon-size="iconSize")
    button.order-pack__print-btn(
      v-if="isDetail && showPrint"
      type="button"
      @click="$emit('print')"
      aria-label="Imprimir"
    )
      span.material-symbols-outlined(:style="printIconStyle") print
  .order-pack__cell.order-pack__col-message(
    :class="{ 'order-pack__col-message--detail': isDetail }"
    @click.stop=""
  )
    slot(name="message")
</template>

<script>
import shCheckbox from '@/components/elements/Checkbox'
import RemitDataIcon from '@/components/elements/remit/RemitDataIcon.vue'
import { recordProductQuantity } from '@/helpers/productQuantity'

export default {
  name: 'PackListChangeRow',

  components: { shCheckbox, RemitDataIcon },

  props: {
    item: { type: Object, required: true },
    isDetail: { type: Boolean, default: false },
    showCheck: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    linkIds: { type: Boolean, default: false },
    name: { type: String, default: '' },
    location: { type: String, default: '' },
    dateLabel: { type: String, default: '' },
    statusLabel: { type: String, default: '' },
    statusStyle: { type: Object, default: () => ({}) },
    iconColor: { type: String, default: 'var(--color-placeholder)' },
    iconSize: { type: String, default: '1.75rem' },
    showPrint: { type: Boolean, default: false },
    printIconStyle: { type: Object, default: () => ({}) }
  },

  computed: {
    rowClass () {
      return {
        'order-pack__row--detail': this.isDetail,
        'is-selected': !this.isDetail && this.selected
      }
    },

    productQuantity () {
      return recordProductQuantity(this.item)
    }
  },

  methods: {
    onChangeClick () {
      if (this.linkIds) this.$emit('open-change', this.item.change)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/pack/PackListChangeRow.vue